// Mock data for herbal shop e-commerce

export const products = [
  // Soaps
  {
    id: 'soap-1',
    name: 'Lavender Dream Soap',
    category: 'soaps',
    price: 12.99,
    image: 'https://images.unsplash.com/photo-1605264964528-06403738d6dc',
    description: 'Handcrafted lavender soap with organic essential oils. Calming and moisturizing for all skin types.',
    ingredients: 'Organic olive oil, coconut oil, lavender essential oil, shea butter',
    inStock: true,
    featured: true
  },
  {
    id: 'soap-2',
    name: 'Eucalyptus Mint Soap',
    category: 'soaps',
    price: 11.99,
    image: 'https://images.unsplash.com/photo-1618840313409-66c0d92d6f26',
    description: 'Refreshing eucalyptus and peppermint soap. Perfect for morning showers.',
    ingredients: 'Coconut oil, eucalyptus oil, peppermint oil, glycerin',
    inStock: true,
    featured: false
  },
  {
    id: 'soap-3',
    name: 'Rose & Honey Soap',
    category: 'soaps',
    price: 13.99,
    image: 'https://images.pexels.com/photos/6366358/pexels-photo-6366358.jpeg',
    description: 'Luxurious rose and honey soap for gentle cleansing and nourishment.',
    ingredients: 'Raw honey, rose petals, almond oil, vitamin E',
    inStock: true,
    featured: true
  },
  {
    id: 'soap-4',
    name: 'Charcoal Detox Soap',
    category: 'soaps',
    price: 14.99,
    image: 'https://images.pexels.com/photos/7500300/pexels-photo-7500300.jpeg',
    description: 'Activated charcoal soap for deep cleansing and detoxification.',
    ingredients: 'Activated charcoal, tea tree oil, coconut oil, clay',
    inStock: true,
    featured: false
  },

  // Herbs
  {
    id: 'herb-1',
    name: 'Organic Chamomile',
    category: 'herbs',
    price: 8.99,
    image: 'https://images.unsplash.com/photo-1630057135574-6ac3a75fbdf7',
    description: 'Premium dried chamomile flowers. Perfect for tea and relaxation.',
    ingredients: '100% organic chamomile flowers',
    inStock: true,
    featured: true
  },
  {
    id: 'herb-2',
    name: 'Peppermint Leaves',
    category: 'herbs',
    price: 7.99,
    image: 'https://images.pexels.com/photos/7526066/pexels-photo-7526066.jpeg',
    description: 'Fresh dried peppermint leaves for tea and digestive health.',
    ingredients: '100% organic peppermint leaves',
    inStock: true,
    featured: false
  },
  {
    id: 'herb-3',
    name: 'Lavender Buds',
    category: 'herbs',
    price: 9.99,
    image: 'https://images.unsplash.com/photo-1729324738509-7935838d5ef9',
    description: 'Aromatic lavender buds for relaxation and sleep support.',
    ingredients: '100% organic lavender buds',
    inStock: true,
    featured: true
  },

  // Crystals
  {
    id: 'crystal-1',
    name: 'Amethyst Cluster',
    category: 'crystals',
    price: 34.99,
    image: 'https://images.unsplash.com/photo-1643319125503-f9d079d64b9a',
    description: 'Natural amethyst crystal cluster for spiritual healing and meditation.',
    ingredients: 'Natural amethyst crystal',
    inStock: true,
    featured: true
  },
  {
    id: 'crystal-2',
    name: 'Rose Quartz',
    category: 'crystals',
    price: 24.99,
    image: 'https://images.unsplash.com/photo-1630908318796-5998f64b07cf',
    description: 'Rose quartz crystal for love, compassion, and emotional healing.',
    ingredients: 'Natural rose quartz',
    inStock: true,
    featured: false
  },
  {
    id: 'crystal-3',
    name: 'Clear Quartz Point',
    category: 'crystals',
    price: 29.99,
    image: 'https://images.pexels.com/photos/3610753/pexels-photo-3610753.jpeg',
    description: 'Clear quartz crystal point for amplifying energy and clarity.',
    ingredients: 'Natural clear quartz',
    inStock: true,
    featured: true
  },
  {
    id: 'crystal-4',
    name: 'Mixed Crystal Set',
    category: 'crystals',
    price: 44.99,
    image: 'https://images.pexels.com/photos/6998577/pexels-photo-6998577.jpeg',
    description: 'Curated set of healing crystals for beginners.',
    ingredients: 'Amethyst, rose quartz, citrine, clear quartz',
    inStock: true,
    featured: false
  },

  // Jewelry
  {
    id: 'jewelry-1',
    name: 'Amethyst Necklace',
    category: 'jewelry',
    price: 49.99,
    image: 'https://images.unsplash.com/photo-1758974504487-74d46fa07242',
    description: 'Handcrafted amethyst crystal necklace with silver chain.',
    ingredients: 'Amethyst crystal, sterling silver chain',
    inStock: true,
    featured: true
  },
  {
    id: 'jewelry-2',
    name: 'Rose Quartz Bracelet',
    category: 'jewelry',
    price: 32.99,
    image: 'https://images.unsplash.com/photo-1758974504337-cc6078b1cc42',
    description: 'Elegant rose quartz beaded bracelet for daily wear.',
    ingredients: 'Rose quartz beads, elastic cord',
    inStock: true,
    featured: false
  },
  {
    id: 'jewelry-3',
    name: 'Crystal Healing Bracelet',
    category: 'jewelry',
    price: 39.99,
    image: 'https://images.unsplash.com/photo-1699599204718-fbc583516ea9',
    description: 'Multi-crystal bracelet with chakra balancing stones.',
    ingredients: 'Mixed healing crystals, adjustable cord',
    inStock: true,
    featured: true
  },

  // Herbal Remedies
  {
    id: 'remedy-1',
    name: 'Sleep Support Tincture',
    category: 'remedies',
    price: 24.99,
    image: 'https://images.unsplash.com/photo-1674316206411-52408f9a5b5d',
    description: 'Herbal tincture blend to promote restful sleep and relaxation.',
    ingredients: 'Valerian root, passionflower, chamomile, alcohol base',
    inStock: true,
    featured: true
  },
  {
    id: 'remedy-2',
    name: 'Immune Boost Tea Blend',
    category: 'remedies',
    price: 16.99,
    image: 'https://images.pexels.com/photos/7852673/pexels-photo-7852673.jpeg',
    description: 'Herbal tea blend to support immune system health.',
    ingredients: 'Echinacea, elderberry, ginger, lemon balm',
    inStock: true,
    featured: false
  },
  {
    id: 'remedy-3',
    name: 'Digestive Comfort Tea',
    category: 'remedies',
    price: 14.99,
    image: 'https://images.pexels.com/photos/7526066/pexels-photo-7526066.jpeg',
    description: 'Soothing herbal blend for digestive wellness.',
    ingredients: 'Peppermint, ginger, fennel, chamomile',
    inStock: true,
    featured: true
  }
];

export const categories = [
  {
    id: 'soaps',
    name: 'Handmade Soaps',
    description: 'Organic and natural soaps crafted with care',
    image: 'https://images.unsplash.com/photo-1605264964528-06403738d6dc'
  },
  {
    id: 'herbs',
    name: 'Dried Herbs',
    description: 'Premium quality organic herbs for wellness',
    image: 'https://images.unsplash.com/photo-1630057135574-6ac3a75fbdf7'
  },
  {
    id: 'crystals',
    name: 'Healing Crystals',
    description: 'Natural crystals for spiritual wellness',
    image: 'https://images.unsplash.com/photo-1643319125503-f9d079d64b9a'
  },
  {
    id: 'jewelry',
    name: 'Crystal Jewelry',
    description: 'Handcrafted necklaces and bracelets',
    image: 'https://images.unsplash.com/photo-1758974504487-74d46fa07242'
  },
  {
    id: 'remedies',
    name: 'Herbal Remedies',
    description: 'Natural solutions for holistic wellness',
    image: 'https://images.unsplash.com/photo-1674316206411-52408f9a5b5d'
  }
];

export const testimonials = [
  {
    id: 1,
    name: 'Sarah Mitchell',
    rating: 5,
    comment: 'The lavender soap is amazing! My skin has never felt better. The quality is outstanding.',
    product: 'Lavender Dream Soap'
  },
  {
    id: 2,
    name: 'Michael Chen',
    rating: 5,
    comment: 'Love the healing crystals! The energy in my home has completely shifted. Highly recommend!',
    product: 'Amethyst Cluster'
  },
  {
    id: 3,
    name: 'Emily Rodriguez',
    rating: 5,
    comment: 'The sleep tincture works wonders. I finally get restful sleep naturally. Thank you!',
    product: 'Sleep Support Tincture'
  },
  {
    id: 4,
    name: 'David Thompson',
    rating: 5,
    comment: 'Beautiful crystal necklace and great customer service. Will definitely order again!',
    product: 'Amethyst Necklace'
  }
];

export const aboutContent = {
  title: 'Our Story',
  subtitle: 'Supporting Your Spiritual Journey',
  description: 'Let us cater to your spiritual essential needs. We strive to support your spiritual journey by supplying you items you may need to facilitate your spiritual growth. Our shop offers carefully curated products - from handcrafted soaps to healing crystals - all sourced ethically and created with intention.',
  mission: 'To provide authentic, high-quality spiritual and natural products that nurture your spiritual growth and support your wellness journey.',
  values: [
    { title: 'Natural Ingredients', description: 'Only the finest organic and natural materials' },
    { title: 'Ethical Sourcing', description: 'Sustainably and responsibly sourced products' },
    { title: 'Handcrafted Quality', description: 'Made with care and intention' },
    { title: 'Holistic Wellness', description: 'Supporting mind, body, and spirit' }
  ]
};
